import React from 'react';
import PropTypes from 'prop-types';
import { Provider } from 'react-redux';
import { Router } from '../routes';
import Notification from '../components/Notification';
import { QueryClientProvider } from 'react-query';
import queryClient from '../config/queryClient';

const Root = ({ store = {} }) => {
  return (
    <QueryClientProvider client={queryClient}>
      <Provider store={store.store}>
        <Router history={store.history} />
        <Notification />
      </Provider>
    </QueryClientProvider>
  );
};

Root.propTypes = {
  store: PropTypes.objectOf(PropTypes.any),
};

export default Root;
